var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50012 10.2003L2.00012 6.70031C1.61012 6.31031 0.990117 6.31031 0.600117 6.70031C0.210117 7.09031 0.210117 7.71031 0.600117 8.10031L4.79012 12.2903C5.18012 12.6803 5.81012 12.6803 6.20012 12.2903L16.8001 1.70031C17.1901 1.31031 17.1901 0.690313 16.8001 0.300312C16.4101 -0.0896875 15.7901 -0.0896875 15.4001 0.300312L5.50012 10.2003Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.7dd81aaf8485cd3dde76207f1fd15fcb.svg";
export { ForwardRef as ReactComponent };